import { z } from 'zod'

export * from './assistant.ts'
export * from './assistant-reasoning.ts'
export * from './directory-import.ts'
export * from './finance.ts'
export * from './inbox.ts'
export * from './logistics.ts'
export * from './notices.ts'
export * from './permissions.ts'
export * from './records.ts'
export * from './sales-customers.ts'
export * from './sales-orders.ts'
export * from './settings.ts'
export * from './staff.ts'
export * from './task-records.ts'
export * from './tasks.ts'
export const decimalSchema = z.string().regex(/^-?\d+(\.\d+)?$/)
export const signInSchema = z.object({ email: z.email(), password: z.string().min(1) }).strict()
export const referenceRecordSchema = z
  .object({
    id: z.string(),
    version: z.number().int().positive(),
  })
  .passthrough()
export const apiErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
})
export type ApiEnvelope<T> =
  | { ok: true; data: T }
  | { ok: false; error: z.infer<typeof apiErrorSchema> }
export * from './catalog.ts'
export * from './documents.ts'
export * from './engineering.ts'
export * from './production.ts'
export * from './proposal-letter.ts'
export type { ProposalPrint, ProposalPrintLetter } from './proposal-print.ts'
export * from './purchasing.ts'
export * from './suppliers.ts'
export * from './warehouse.ts'
